import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { faqData } from "./items/items-faqs";

const FAQS = ({ name }) => {
    const navigate = useNavigate();
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [openIndex, setOpenIndex] = useState(null);

    function getFaqsByFeature(ft) {
        switch (ft) {
            case "meetings":      return faqData.meetings;
            case "plansandtasks": return faqData.plansandtasks;
            case "documents":     return faqData.documents;
            case "workspace":     return faqData.workspace;
            case "projects":      return faqData.projects;
            default:              return [];
        }
    }

    const faqs = getFaqsByFeature(name);

    const handleNavigation = (section) => {
        if (section === "contact") {
            navigate("/contact-us");
        } else {
            document.getElementById(section)?.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <section id="faqs">
            <div className="faq-container">
                <h2 className="h1-48-800">Your Questions, <span>Answered</span></h2>
                <p className="faq-description">
                    We've compiled a list of the most frequently asked questions about ConRa to help you get the information you need.
                </p>

                <div className="faq-qa-border">
                    {/* ── Desktop two-column layout ── */}
                    <div className="faq-desktop">
                        <div className="faq-desktop-questions">
                            {faqs.map((faq, index) => (
                                <button
                                    key={index}
                                    className={`faq-desktop-q ${selectedIndex === index ? "faq-desktop-q--active" : ""}`}
                                    onClick={() => setSelectedIndex(index)}
                                >
                                    {faq.question}
                                </button>
                            ))}
                        </div>
                        <div className="faq-desktop-answer">
                            <p>{faqs[selectedIndex]?.answer}</p>
                        </div>
                    </div>

                    {/* ── Mobile accordion layout ── */}
                    <div className="faq-mobile">
                        {faqs.map((faq, index) => (
                            <div
                                key={index}
                                className={`faq-item ${openIndex === index ? "open" : ""}`}
                                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                            >
                                <div className="faq-question">
                                    {faq.question}
                                    <span className="icon">{openIndex === index ? "−" : "+"}</span>
                                </div>
                                {openIndex === index && <div className="faq-answer">{faq.answer}</div>}
                            </div>
                        ))}
                    </div>
                </div>{/* end faq-qa-border */}

                <div className="faq-footer">
                    <p>Still have questions? We're here to help!</p>
                    <button onClick={() => handleNavigation("contact")} className="faq-button">Contact Support</button>
                </div>
            </div>
        </section>
    );
};

export default FAQS;
